import {prepareOptions} from '../../helpers/common';

require('./e3-close-button.scss');

class E3CloseButton {
    _options = {
        classNames: [],
        events: {}
    };
    _element = null;
    _container = null;

    constructor(container, options) {
        this._options = prepareOptions(this._options, options);
        this._container = container;
        this._element = this._createElement();

        this._bindEvents();
    }

    _createElement() {
        const element = document.createElement('div');
        const {classNames} = this._options;

        element.classList.add('e3-close-button');
        classNames
            .forEach((className) => element.classList.add(className));

        this._container.appendChild(element);

        return element;
    }

    _bindEvents() {
        const {events} = this._options;

        Object.keys(events)
            .forEach((event) => this._element.addEventListener(event, events[event]))
    }

    _unbindEvents() {
        const {events} = this._options;

        Object.keys(events)
            .forEach((event) => this._element.removeEventListener(event, events[event]))
    }

    element() {
        return this._element;
    }

    show() {
        this._element.classList.add('e3-close-button--show');
    }

    destroy() {
        this._unbindEvents();
        this._container.removeChild(this._element)
    }
}

export default E3CloseButton;